import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import { addProduct, updateProduct } from "./api";

function Add(props) {
  // ==================== GET DEFAULTS ==================== //
  const lState = props.location.state;
  const isAddPage = props.match.params.id === undefined;
  // ==================== GET DEFAULTS ==================== //

  // ==================== COMPONENET STATE ==================== //
  const [url, seturl] = useState(lState ? lState.URL : "");
  const [name, setname] = useState(lState ? lState.name : "");
  const [domain, setdomain] = useState(lState ? lState.domain : "");
  const [description, setdescription] = useState(
    lState ? lState.description : ""
  );
  const [dSelectors, setdSelectors] = useState(
    lState ? JSON.stringify(lState.dSelectors) : ""
  );
  const [mSelectors, setmSelectors] = useState(
    lState ? JSON.stringify(lState.mSelectors) : ""
  );
  const [status, setstatus] = useState(false);
  // ==================== COMPONENET STATE ==================== //

  // ==================== COMPONENT VARIABLES ==================== //
  let buttonText = "Submit";

  switch (status) {
    case "loading":
      buttonText = "Submitting...";
      break;
    case "success":
      buttonText = "Successful";
      break;
    case "error":
      buttonText = "Error";
      break;

    default:
      break;
  }
  // ==================== COMPONENT VARIABLES ==================== //

  return (
    <Wrapper>
      <form id="add-sellers">
        <input
          className="field"
          name="URL"
          placeholder="URL"
          value={url}
          onBlur={(e) => {
            try {
              let url = e.target.value;
              seturl(url);
              const urlObj = new URL(url);
              const domain = urlObj.host.replace(/www.|.in|.com/gi, "");
              setdomain(domain);
              setname(domain.charAt(0).toUpperCase() + domain.substring(1));
            } catch (error) {
              console.log(error);
            }
          }}
          onChange={(e) => {
            let url = e.target.value;
            seturl(url);
          }}
        />
        <input
          className="field"
          name="name"
          placeholder="name"
          value={name}
          onChange={(e) => {
            setname(e.target.value);
          }}
        />
        <input
          className="field"
          name="domain"
          placeholder="domain"
          value={domain}
          onChange={(e) => {
            setdomain(e.target.value);
          }}
        />
        <textarea
          className="field"
          name="description"
          placeholder="description"
          rows={3}
          value={description}
          onChange={(e) => {
            setdescription(e.target.value);
          }}
        />
        <textarea
          className="field"
          name="dSelectors"
          placeholder="desktop selectors"
          rows={3}
          value={dSelectors}
          onChange={(e) => {
            setdSelectors(e.target.value);
          }}
        />
        <textarea
          className="field"
          name="mSelectors"
          placeholder="mobile selectors"
          rows={3}
          value={mSelectors}
          onChange={(e) => {
            setmSelectors(e.target.value);
          }}
        />
        <button
          onClick={async (e) => {
            e.preventDefault();
            let data = {};
            document
              .querySelector("#add-sellers")
              .querySelectorAll(".field")
              .forEach((e) => {
                data[e.name] = e.value;
              });
            setstatus("loading");

            const res = isAddPage
              ? await addProduct(data)
              : updateProduct(props.match.params.id, data);
            if (res) {
              setstatus("success");
            } else {
              setstatus("error");
            }
          }}
        >
          {buttonText}
        </button>
      </form>
    </Wrapper>
  );
}

export default withRouter(Add);
// "name": "Amazon",
// "description": "Amazon.in: Online Shopping India - Buy mobiles, laptops, cameras, books, watches, apparel, shoes and e-Gift Cards. Free Shipping & Cash on Delivery Available.",
// "domain": "amazon",
// "URL": "https://www.amazon.in",
// "logo": "logo",
// "dSelectors": {"title":{"css":"h1.prod-name","type":"Text"},"price":{"css":"div.prod-sp","type":"Text"},"brand":{"css":"h2.brand-name","type":"Text"},"offers":{"css":"div.promo-blck","multiple":true,"type":"Text"},"size_instock":{"css":"div.size-instock","multiple":true,"type":"Text"},"size_outofstock":{"css":"div.swatch-size-oos","multiple":true,"type":"Text"},"details":{"css":"li.detail-list","multiple":true,"type":"Text"},"image":{"css":"img.rilrtl-lazy-img","type":"Attribute","attribute":"src"}},
// "mSelectors": {"title": { "css": "span[id=productTitle]", "type": "Text" },"price": [{ "css": "span[id=priceblock_ourprice]", "type": "Text" },{ "css": "span[id=priceblock_saleprice]", "type": "Text" },{ "css": "span[id=priceblock_dealprice]", "type": "Text" }],"tags": {"css": "div.a-breadcrumb a.a-link-normal","multiple": true,"type": "Text"},"description": {"css": "ul.a-unordered-list.a-spacing-mini li span.a-list-item","multiple": true,"type": "Text"},"image": {"css": "img[id=landingImage]","multiple": true,"type": "Attribute","attribute": "src"},"offers": {"css": "ul.a-unordered-list.a-spacing-small > li span.a-list-item","multiple": true,"type": "Text"}}
